<template>
  <div class="citic-page-header">
    <h2>{{pageTitle}}</h2>
    <div class="actions">
      <slot></slot>
    </div>
    <div class="search-box">
      <slot name="search-box">
        <!-- <search-box></search-box> -->
      </slot>
    </div>
  </div>
</template>
<script>
import SearchBox from '../widgets/widgetSearchBox'

export default {
  name: 'ThePageHeader',
  props: ['page-title'],
  components: {
    SearchBox
  }
}
</script>
<style lang="scss">
  .citic-page-header {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    justify-content: space-between;
    h2 {
      margin: 0;
      font-size: 1.5em;
    }
    .actions {
      flex-grow: 1;
      justify-content: space-between;
      display: flex;
      a.button {
        margin: 0 20px 0 20px;
        padding-left: 20px;
        border-left: 1px solid #999;
        display: inline-block;
        text-align: center;
        i {
          font-size: 32px;
          margin-bottom: 5px
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// ThePageHeader.vue?043f0b6f